import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AddCenterDialog } from "../components/dialogs";
import { Stack, Typography, Box } from "@mui/material";
import { useGetCentersQuery } from "../../../services/ConfigurationService";
import { CenterType } from "../../../services/ConfigurationService/types/centerType";
import { CenterGrid } from "../components/grids";
import { PageLoading as Loading } from "../../common/components";
import PageCard from '../../common/components/styled-ui-elements/PageCard';

const PAGE_STYLES = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: '100vh',
    padding: 3,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 3,
    borderBottom: '2px solid #3b82f6',
    backgroundColor: '#ffffff',
  },
  content: {
    padding: 3,
    backgroundColor: '#ffffff',
  }
};

function Centers() {
  const { company } = useParams();
  const navigate = useNavigate();
  const { data: centers = [], isLoading, error, refetch } = useGetCentersQuery({ company: company || "" });

  const handleEdit = (center: CenterType) => {
    navigate(`/center-detail/${center.id}?company=${company}`);
  };

  return (
    <Box sx={PAGE_STYLES.container}>
      {isLoading ? (
        <Loading />
      ) : error ? (
        <PageCard>
          <Box sx={PAGE_STYLES.content}>
            <Typography color="error" variant="h6" align="center">
              Error loading centers
            </Typography>
          </Box>
        </PageCard>
      ) : (
        <PageCard>
          {/* Header Section */}
          <Box sx={PAGE_STYLES.header}>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#1e293b' }}>
              Centers for Company: {company}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <AddCenterDialog organization={company} />
            </Box>
          </Box>

          {/* Content Section */}
          <Box sx={PAGE_STYLES.content}>
            <CenterGrid 
              centers={centers} 
              onCenterClick={handleEdit}
              onCenterSaved={refetch}
            />
          </Box>
        </PageCard>
      )}
    </Box>
  );
}

export { Centers };

